module.exports = {
  name: 'x-footer',
  view: require('./view.html')
}
